import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class NewsletterService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.newsletter.listUrl, ServiceConfig.newsletter.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/newsletter.service.ts